import React, { useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getPermisos } from 'redux/permisosSlice';
import classNames from 'classnames';

export const TablaPermisos = ({ roleToPermission }) => {
  const tablaPermisos = useSelector(state => state.permisos.data);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPermisos());
  }, []);

  const groupsRender = tablaPermisos
    .map(grupo => {
      const permisosRender = grupo.permissions
        .map((perm, index) =>
          roleToPermission.some(rtp => {
            return rtp.permission.key === perm.key;
          }) ? (
            <Col as="li" xs={12} md={6} key={index}>
              <label>{perm.permissionName}</label>
            </Col>
          ) : null
        )
        .filter(permiso => permiso !== null);

      return permisosRender.length ? { ...grupo, permisosRender } : null;
    })
    .filter(group => group !== null);

  return groupsRender.map((grupo, index) => (
    <div key={index}>
      <Form.Label className="text-dark">
        <strong>{grupo.name}</strong>
      </Form.Label>

      <Row
        as="ul"
        className={classNames('d-flex flex-row flex-wrap', {
          'mb-0': index === groupsRender.length - 1
        })}
      >
        {grupo.permisosRender}
      </Row>
    </div>
  ));
};
TablaPermisos.propTypes = {
  roleToPermission: PropTypes.array.isRequired
};
